import bsiLogo from "@/assets/logos/vvb/bsi.png";
import controlUnionLogo from "@/assets/logos/vvb/control-union.png";
import tuvNordLogo from "@/assets/logos/vvb/tuv-nord-new.png";
import bureauVeritasLogo from "@/assets/logos/vvb/bureau-veritas.png";
import pwcLogo from "@/assets/logos/vvb/pwc.png";
import sgsLogo from "@/assets/logos/vvb/sgs.png";
import tuvRheinlandLogo from "@/assets/logos/vvb/tuv-rheinland.png";

const vvbLogos = [
  { name: "PwC - Sustainwize hotel sustainability verification partner", src: pwcLogo },
  { name: "TÜV NORD - GSTC certification body partner", src: tuvNordLogo },
  { name: "Bureau Veritas - Hotel sustainability audit partner", src: bureauVeritasLogo },
  { name: "BSI - Sustainability standards certification partner", src: bsiLogo },
  { name: "TÜV Rheinland - Environmental management verification partner", src: tuvRheinlandLogo },
  { name: "Control Union - Sustainable tourism certification partner", src: controlUnionLogo },
  { name: "SGS - Hotel environmental compliance verification partner", src: sgsLogo },
];

const SustainwizeVVBSection = () => {
  return (
    <section className="py-16 lg:py-20 bg-background relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="border-t border-border/50 pt-12 overflow-hidden">
          <h2 className="text-center text-xl sm:text-2xl font-semibold text-muted-foreground tracking-wide mb-8">
            VVBs Working with Carbonwize
          </h2>
          <div className="relative">
            <div className="flex animate-scroll-left">
              {/* First set of logos */}
              {vvbLogos.map((logo, index) => (
                <div
                  key={`first-${index}`}
                  className="flex-shrink-0 mx-6 sm:mx-12 flex items-center justify-center"
                >
                  <img 
                    src={logo.src} 
                    alt={logo.name}
                    className="h-8 sm:h-12 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
                  />
                </div>
              ))}
              {/* Duplicate set for seamless loop */}
              {vvbLogos.map((logo, index) => (
                <div
                  key={`second-${index}`}
                  className="flex-shrink-0 mx-6 sm:mx-12 flex items-center justify-center"
                >
                  <img 
                    src={logo.src} 
                    alt={logo.name}
                    className="h-8 sm:h-12 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SustainwizeVVBSection;
